/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/394-google2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975.591 4.019 1.569L10.51 5.138c-.447-.428-1.225-.925-2.391-.925C6.069 4.213 4.4 5.91 4.4 8s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588H8.119V7.143h5.666c.05.3.094.6.094.994C13.882 11.565 11.585 14 8.12 14z"/>'
  }
})
